import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import CuentasPorCobrar from '../../components/vendors/CuentasPorCobrarRefactored';
import RefactoredVentasPorMes from '../../components/vendors/RefactoredVentasPorMes';
import routes from '../../helpers/routes';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8em;
  width: 100%;
  height: 100%;
  padding: 0.5em;
  
  // Optimización para móvil
  @media (max-width: 768px) {
    padding: 0.25em;
    gap: 0.5em;
  }
`;

const MenuItem = styled.button`
  cursor: pointer;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.8em 1em;
  border: 1px solid #6c757d;
  border-radius: 6px;
  background-color: white;
  color: #495057;
  transition: all 0.2s ease;
  font-size: 1rem;
  
  @media (max-width: 768px) {
    padding: 1em;
    font-size: 1.1rem;
    min-height: 3rem;
  }
  
  &:hover {
    background-color: #6c757d;
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

type ViewType = 'menu' | 'cuentas' | 'ventas';

interface VendorDashboardProps {
  user: any;
}

export const VendorDashboard: React.FC<VendorDashboardProps> = ({ user }) => {
  const [activeView, setActiveView] = React.useState<ViewType>('menu');
  const history = useHistory();

  const renderActiveView = () => {
    switch (activeView) {
      case 'cuentas':
        return <CuentasPorCobrar onBack={() => setActiveView('menu')} />;
      case 'ventas':
        return <RefactoredVentasPorMes onBack={() => setActiveView('menu')} />;
      default:
        return null;
    }
  };

  return (
    <Container>
      {activeView === 'menu' ? (
        <>
          <MenuItem onClick={() => setActiveView('cuentas')}>
            💰 Cuentas por cobrar
          </MenuItem>
          <MenuItem onClick={() => history.push(routes.vendor.cobros)}>
            💵 Ver Cobros
          </MenuItem>
          <MenuItem onClick={() => setActiveView('ventas')}>
            📊 Ventas del mes
          </MenuItem>
        </>
      ) : (
        renderActiveView()
      )}
    </Container>
  );
};

export default VendorDashboard;
